var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMenuHomeActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4751 14H10.4751V21H14.4751V14Z",
    fill: "#7126FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8952 10.1799L13.1852 2.29995C13.0922 2.20622 12.9816 2.13183 12.8598 2.08106C12.7379 2.03029 12.6072 2.00415 12.4752 2.00415C12.3432 2.00415 12.2125 2.03029 12.0906 2.08106C11.9688 2.13183 11.8582 2.20622 11.7652 2.29995L4.05521 10.1899C3.86865 10.378 3.72131 10.6013 3.62174 10.8468C3.52217 11.0922 3.47237 11.3551 3.47521 11.6199V19.9999C3.47444 20.5119 3.66999 21.0046 4.02159 21.3766C4.37319 21.7487 4.85407 21.9718 5.36521 21.9999H8.47521V12.9999C8.47521 12.7347 8.58057 12.4804 8.76811 12.2928C8.95564 12.1053 9.21 11.9999 9.47521 11.9999H15.4752C15.7404 11.9999 15.9948 12.1053 16.1823 12.2928C16.3699 12.4804 16.4752 12.7347 16.4752 12.9999V21.9999H19.5852C20.0964 21.9718 20.5772 21.7487 20.9288 21.3766C21.2804 21.0046 21.476 20.5119 21.4752 19.9999V11.6199C21.476 11.0829 21.268 10.5665 20.8952 10.1799Z",
    fill: "#7126FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuHomeActive);
export default __webpack_public_path__ + "static/media/icon_menu_home_active.26109497eadd1d3f4bcbf7db5b77811c.svg";
export { ForwardRef as ReactComponent };